module.exports = __webpack_public_path__ + "img/sape.48acd114.png";